import { Box } from "@mui/material";
import IconContainer from "../../components/IconContainer";
import { ReactComponent as BreezeSVG } from "../../scenes/stack/environment/icons/logos/breeze-24.svg";

export default function IconContainerDemo() {
  return (
    <Box display="flex" gap={2}>
      {["L", "M", "S", "XS"].map((size) => (
        <IconContainer key={size} IconSVG={BreezeSVG} size={size} />
      ))}
    </Box>
  );
}
